<template>
    <div class="flex items-center space-x-3">
        <div role="checkbox" tabindex="0" aria-checked="false"
             @click="handleClick"
             class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring"
             :class="[on ? activeColorBgClass : 'bg-gray-200']">

            <!-- On: "translate-x-5", Off: "translate-x-0" -->
            <span aria-hidden="true" class="translate-x-0 relative inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200"
                  :class="{'translate-x-5': on, 'translate-x-0': off}">

                <!-- On: "opacity-0 ease-out duration-100", Off: "opacity-100 ease-in duration-200" -->
                <div class="opacity-100 ease-in duration-200 absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                     :class="{'opacity-0 ease-out duration-100': on, 'opacity-100 ease-in duration-200': off}">
                    <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12" v-show="off">
                        <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <!-- On: "opacity-100 ease-in duration-200", Off: "opacity-0 ease-out duration-100" -->
                <div class="opacity-0 ease-out duration-100 absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                     :class="{'opacity-100 ease-in duration-200': on, 'opacity-0 ease-out duration-100': off}">
                    <svg class="h-3 w-3" :class="[on ? activeColorTextClass : 'bg-gray-200']" fill="currentColor" viewBox="0 0 12 12" v-show="on">
                        <path
                            d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"/>
                    </svg>
                </div>
            </span>
        </div>

        <span>
            <span class="text-sm leading-5 text-gray-900 select-none font-medium">
                <slot></slot>
            </span>
        </span>
    </div>
</template>

<script>
export default {
    name: "Toggle",
    props: {
        value: {
            default: false,
            type: Boolean
        },
        disabled: {
            default: false,
            type: Boolean
        },
        activeColorBgClass: {
            type: String,
            required: false,
            default: "bg-indigo-600"
        },
        activeColorTextClass: {
            type: String,
            required: false,
            default: "text-gray-800"
        }
    },
    data () {
        return {
            toggleValue: this.value
        };
    },
    computed: {
        on () {
            return this.toggleValue === true;
        },
        off () {
            return this.toggleValue === false;
        }
    },
    watch: {
        on (newValue) {
            this.toggleValue = newValue;
            this.$emit("input", newValue);
        },
        value (newValue) {
            this.toggleValue = newValue;
        }
    },
    mounted () {
        this.toggleValue = this.value;
    },
    methods: {
        handleClick () {
            if (!this.disabled) {
                this.toggleValue = !this.toggleValue;
            }
        },
    }
};
</script>
